import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {map, switchMap} from 'rxjs/operators';
import {Apollo} from 'apollo-angular';
import {NotificationService} from '../../../../services/notifications/notification.service';
import {Store} from '@ngrx/store';
import {AppState} from '../../../reducers';
import {ResponseCodesService} from '../../../../services/response-codes/response-codes.service';
import {AuthService} from '../../../../services/auth/auth.service';
import {listAllActionUserTypes, loadActionUserTypes} from './action-user-type.actions';
import {LIST_ALL_ACTION_USER_TYPES} from './action-user-type.graphql';
import {ActionUserType} from './action-user-type.model';


@Injectable()
export class ActionUserTypeEffects {

    listAllActionUserTypes = createEffect(() => this.actions$.pipe(
        ofType(listAllActionUserTypes),
        switchMap((action) => {
            return this.apollo.query({
                query: LIST_ALL_ACTION_USER_TYPES,
                fetchPolicy: 'network-only'
            }).pipe(
                this.notificationService.catchError(),
                map(({data}: any) => {
                    if (data) {
                        this.store.dispatch(loadActionUserTypes({actionUserTypes:
                                Object.values(data)[0] as ActionUserType[]}));
                    }
                })
            );
        })
    ), {dispatch: false});


    constructor(
        private actions$: Actions,
        private apollo: Apollo,
        private notificationService: NotificationService,
        private store: Store<AppState>,
        private responseCodesService: ResponseCodesService,
        private auth: AuthService,
    ) {
    }

}
